import React, { useState, useEffect } from "react";
import { FaPhone } from "react-icons/fa";
import { HiOutlineChevronLeft, HiOutlineChevronRight } from "react-icons/hi";
import "../../css/home.css";
import bg0 from "../../img/banner/ZTO-Banner1.png";
// import bg1 from "../../img/banner/ZTO-Banner2.png";
// import bg2 from "../../img/banner/ZTO-Banner3.png";
// import bg3 from "../../img/banner/ZTO-Banner4.png";

const slides = [
  {
    bgImageUrl: bg0,
    title: "VẬN CHUYỂN TRUNG - VIỆT",
    subtitle:
      "Hàng về Việt Nam trong 2 ngày kể từ khi ký gửi tại kho tại Trung Quốc",
    index: 0,
  },
  {
    bgImageUrl: bg0,
    title: "VẬN CHUYỂN NỘI ĐỊA",
    subtitle: "Thủ tục đơn giản | Vận chuyển nhanh chóng | Hàng hóa an toàn",
    index: 1,
  },
  {
    bgImageUrl: bg0,
    title: "THANH TOÁN HỘ NHÂN DÂN TỆ",
    subtitle: "Giao dịch an toàn - nhanh chóng với nhà cung cấp - cước phí rẻ",
    index: 2,
  },
  {
    bgImageUrl: bg0,
    title: "DỊCH VỤ FULFILLMENT",
    subtitle: "Nhận - lưu trữ - đóng gói - giao hàng - thu hộ - đối soát",
    index: 3,
  },
];

const Banner = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    // Auto slide every 5s
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((next) => (next === slides.length - 1 ? 0 : next + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const bg = `url('${slides[currentSlide].bgImageUrl}')`;

  const handleServiceClick = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="banner-section" style={{ backgroundImage: bg }}>
      <div className="container banner-content">
        <div className="banner-title">{slides[currentSlide].title}</div>
        <div className="banner-subtitle">{slides[currentSlide].subtitle}</div>
        <div className="banner-actions mt-4">
          <div className="d-flex justify-content-center align-items-center">
            <a
              href="https://zalo.me/0364758606"
              alt="Contact via Zalo"
              className="btn btn-success rounded-pill border-0 btn-consultation"
              style={{
                background: "#9bc954",
                padding: "0.75rem",
              }}
            >
              Tư vấn
            </a>
          </div>
        </div>

        <div className="banner-arrows">
          <HiOutlineChevronLeft className="arrow" onClick={prevSlide} />
          <HiOutlineChevronRight className="arrow" onClick={nextSlide} />
        </div>
      </div>

      <div className="banner-services">
        <div
          className={`service-item ${
            currentSlide === 0 ? "bg-white" : "text-white"
          }`}
          onClick={() => handleServiceClick(0)}
        >
          <div className="service-text">
            <span className={currentSlide === 0 ? "color-zto" : "text-white"}>
              VẬN CHUYỂN
            </span>
            <span className={currentSlide === 0 ? "color-zto" : "text-white"}>
              TRUNG - VIỆT
            </span>
          </div>
        </div>
        <div
          className={`service-item ${
            currentSlide === 1 ? "bg-white" : "text-white"
          }`}
          onClick={() => handleServiceClick(1)}
        >
          <div className="service-text">
            <span className={currentSlide === 1 ? "color-zto" : "text-white"}>
              VẬN CHUYỂN
            </span>
            <span className={currentSlide === 1 ? "color-zto" : "text-white"}>
              NỘI ĐỊA
            </span>
          </div>
        </div>
        <div
          className={`service-item ${
            currentSlide === 2 ? "bg-white" : "text-white"
          }`}
          onClick={() => handleServiceClick(2)}
        >
          <div className="service-text">
            <span className={currentSlide === 2 ? "color-zto" : "text-white"}>
              THANH TOÁN
            </span>
            <span className={currentSlide === 2 ? "color-zto" : "text-white"}>
              HỘ NHÂN DÂN TỆ
            </span>
          </div>
        </div>
        <div
          className={`service-item ${
            currentSlide === 3 ? "bg-white" : "text-white"
          }`}
          onClick={() => handleServiceClick(3)}
        >
          <div className="service-text">
            <span className={currentSlide === 3 ? "color-zto" : "text-white"}>
              DỊCH VỤ
            </span>
            <span className={currentSlide === 3 ? "color-zto" : "text-white"}>
              FULFILLMENT
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
